import { render, staticRenderFns } from "./WPBlockInfo.vue?vue&type=template&id=5f2a97b4"
import script from "./WPBlockInfo.vue?vue&type=script&lang=ts"
export * from "./WPBlockInfo.vue?vue&type=script&lang=ts"
import style0 from "./WPBlockInfo.vue?vue&type=style&index=0&id=5f2a97b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports